import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as FeedbackModalImg} from '../../assets/chat05/feedback-modal.svg';
import {ReactComponent as FeedbackImg} from '../../assets/chat05/feedback.svg';
import {ReactComponent as FeedforwardImg} from '../../assets/chat05/feedforward.svg';

export default function Chat05() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');

    const dataMap = [
        { 
            type: 'feedback',
            title: '피드백',
            subTitle: '더 나은 챗봇 경험을 위해 사용자의 목소리를 반영해요',
            Image: FeedbackModalImg
        },
        { 
            type: 'feedforward',
            title: '피드백 관리 페이지',
            subTitle: '관리자와 직접적으로 소통하며 성능을 개선해요',
            Image: FeedforwardImg
        }
    ];

    return (
        <FeatureCardBox
            type='feedback'
            IconImage={FeedbackImg}
            keyword='사용자용 피드백'
            title={mobileSmall ? <>사용자들의 피드백을 통해<br /> 발전하세요!</> : '사용자들의 피드백을 통해 발전하세요!'}
            featureCardList={dataMap}
            titleMotion={serviceMotionList.titleMotion}
            cardMotion={serviceMotionList.cardMotion}
        />
    );
}
